<div class="container">
  <h1>DEM Client</h1>
  <p>Welcome to the DEM Client. Please login to use the tool</p>
  <app-button (click)="login()">LOGIN</app-button>
</div>
